import { FC, memo } from 'react';
import { sortCriteria } from 'store/search/utils';
import CriteriaSimpleList from './components/CriteriaSimpleList';
import CriteriaMultiList from './components/CriteriaMultiList';
import { sortByBlocks } from './utils';
import { Page } from './types';
import type { FindCriteriasPropsType } from './types';
import type { CriteriasType } from 'store/search/search.types';

const CriteriasList: FC<FindCriteriasPropsType> = memo(
	({
		allCriterias,
		activeCriterias,
		block,
		handlerOnChange,
		isHandlerFunction,
		simpleList,
		simpleListWithTitles,
		page,
		onAddCondition,
		onDeleteCondition,
		blockTitle,
		titleTooltip,
		onTemplateSelectValueChange,
		convertedTemplate,
		currentTemplate,
		allTemplates,
		onClearTemplateClick,
		hideParametersBlock,
	}) => {
		const sortedCriteriasArray = sortByBlocks(activeCriterias);
		const { complexCriteria, otherCriteria } = sortCriteria(activeCriterias);

		return simpleList ? (
			<CriteriaSimpleList
				allCriterias={allCriterias as CriteriasType[]}
				otherCriteria={otherCriteria}
				complexCriteria={complexCriteria}
				block={block as Page}
				isHandlerFunction={isHandlerFunction}
				handlerOnChange={handlerOnChange}
				page={page}
				onAddCondition={onAddCondition}
				onDeleteCondition={onDeleteCondition}
			/>
		) : (
			<CriteriaMultiList
				simpleListWithTitles={simpleListWithTitles}
				activeCriterias={activeCriterias}
				allCriterias={allCriterias as CriteriasType[]}
				sortedCriterias={sortedCriteriasArray}
				block={block as Page}
				handlerOnChange={handlerOnChange}
				isHandlerFunction={isHandlerFunction}
				page={page}
				onAddCondition={onAddCondition}
				onDeleteCondition={onDeleteCondition}
				blockTitle={blockTitle}
				titleTooltip={titleTooltip}
				onTemplateSelectValueChange={onTemplateSelectValueChange}
				convertedTemplate={convertedTemplate}
				currentTemplate={currentTemplate}
				allTemplates={allTemplates}
				onClearTemplateClick={onClearTemplateClick}
				hideParametersBlock={hideParametersBlock}
			/>
		);
	},
);

export default CriteriasList;
